import React from 'react';
import Loading from '../Components/Loading';

export default function AppSpinner() {
    return (
        <div className="h-screen w-full loading">
            <Loading />
        </div>
    )
}